@if (state() === "loading") {
  <app-loading />
}

@if (state() === "error") {
  <app-error-data [title]="errorMessage() ?? ''" [showRetry]="true" (retry)="retry.emit()" />
}

@if (state() === "success") {
  <app-tables
    [headerItems]="headerItems"
    [rows]="rows()"
    [currentActions]="currentActions()"
    (toggleDropdown)="toggleDropdown($any($event))"
    (actionTrigger)="handleAction($any($event))"
    [isFiltersApplied]="isFiltersApplied()"
    [emptyFilterTitle]="
      isArabic()
        ? 'لم يتم العثور على باقات تطابق الفلاتر. حاول تعديل معايير البحث.'
        : 'No bundles found matching your filters. Try adjusting your search criteria.'
    "
    [emptyContentTitle]="isArabic() ? 'لم يتم العثور على باقات متاحة' : 'No bundles found'"
    [emptyContentDescription]="isArabic() ? 'لا توجد باقات في النظام.' : 'No bundles found in the system.'" />
}
